<template name="modalTip">
  <div>
    <div class="commit-modal" v-show="showComfirmDelete">
      <div class="confirm-wrapper">
        <div class="confirm-header" v-show="comfirmDeleteTxt">
          {{$t('ConfirmToDelete')}}
        </div>
        <div class="confirm-header" v-show="remindTip">
          {{$t('remindAgain')}}
        </div>
        <div class="confirm-btn row">
          <div class="col-6" @click="closest">{{$t('Cancel')}}</div>
          <div class="col-6 confrim" @click="commitData">{{$t('confirm')}}</div>
        </div>
      </div>
    </div>
    <div class="tip commit-modal" v-show="modalDelete">
      <div class="tip-inner">
        <div class="tip-text">{{DeleteText}}</div>
        <router-link to="/" class="go-back" v-show="deleteInvite"><div class="comfirmBtn">{{$t('confirm')}}</div></router-link>
        <div v-show="deleteCheck" class="comfirmBtn" @click="comfirmBtn">{{$t('confirm')}}</div>
        <div v-show="remindTip" class="comfirmBtn" @click="comfirmBtn">{{$t('confirm')}}</div>
        <div v-show="closeMessage" class="comfirmBtn" @click="redirectToLogin">{{$t('confirm')}}</div>
      </div>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'" :z-index="9999"></loading>
  </div>
</template>

<script type="text/javascript">
  import { deleteInvitation, deleteGoodsListByIdAndTicketId, sendRemind, removeMaterial, removeVisitor, securityDeleteGoodsListByIdAndTicketId } from '@/utils/api';
  import { checkNested } from '@/utils/utils';
  import myAuth from '@/utils/auth';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name:'modalTip',
    props:{
      currentStatus: String,
      invitationId: String,
      goodsListId: String,
      approverId: String,
    },
    components: {
      Loading,
    },
    data() {
      return {
        showComfirmDelete: true,
        modalDelete: false,
        DeleteText: '',
        commitTxt: '',
        deleteCheck: false,
        deleteInvite: false,
        remindTip: false,
        comfirmDeleteTxt: false,
        currentVisitor: {},
        currentTxt: '',
        closeMessage: false,
        isLoading: false,
      }
    },
    created: function() {
      if (this.currentStatus == 'deleteInvitationId') {
        this.commitTxt = this.$t('ConfirmToDelete');
      }
    },
    methods: {
      commitData() {
        this.isLoading = true;
        if (this.currentStatus == 'deleteInvitationId' && this.invitationId) {
          this.deleteInvite = true;
          const invitationId = this.invitationId;
          deleteInvitation(invitationId).then((res) => {
            if (checkNested(res, 'data', 'content', 'model')) {
              this.isLoading = false;
              if (res.data.content.status === 1) {
                this.showComfirmDelete = false;
                this.modalDelete = true;
                this.DeleteText = res.data.content.message;
              } else {
                this.showComfirmDelete = false;
                this.modalDelete = true;
                this.DeleteText = res.data.content.message;
              }
            }
          });
        }
        if (this.currentStatus == 'deleteCheckGoods' && this.invitationId && this.goodsListId) {
           const invitationId = this.invitationId;
           const goodsListId = this.goodsListId;
           this.deleteCheck = true;
          //  console.log(goodsListId,invitationId);
           deleteGoodsListByIdAndTicketId(goodsListId,invitationId).then((res) => {
            if (checkNested(res, 'data', 'content', 'model')) {
              this.isLoading = false;
              if (res.data.content.status === 1) {
                this.showComfirmDelete = false;
                this.modalDelete = true;
                this.DeleteText = res.data.content.message;
              } else {
                this.showComfirmDelete = false;
                this.modalDelete = true;
                this.DeleteText = res.data.content.message;
              }
            } else {
              this.showComfirmDelete = false;
              this.modalDelete = true;
              this.DeleteText = res.data.message;
            }
          });
        }
        if (this.currentStatus == 'deleteSecurityCheckGoods' && this.invitationId && this.goodsListId) {
           const invitationId = this.invitationId;
           const goodsListId = this.goodsListId;
           this.deleteCheck = true;
          //  console.log(goodsListId,invitationId);
           securityDeleteGoodsListByIdAndTicketId(goodsListId,invitationId).then((res) => {
            if (checkNested(res, 'data', 'content', 'model')) {
              this.isLoading = false;
              if (res.data.content.status === 1) {
                this.showComfirmDelete = false;
                this.modalDelete = true;
                this.DeleteText = res.data.content.model;
              } else {
                this.showComfirmDelete = false;
                this.modalDelete = true;
                this.DeleteText = res.data.content.message;
              }
            } else {
              this.showComfirmDelete = false;
              this.modalDelete = true;
              this.DeleteText = res.data.message;
            }
          });
        }
        if (this.currentStatus == 'remindApproval') {
          const approverId = this.approverId;
          this.remindTip = true;
          sendRemind(approverId).then((res) => {
            if (checkNested(res, 'data', 'content', 'model')) {
              this.isLoading = false;
             if (res.data.content.status === 1) {
                 this.showComfirmDelete = false;
                 this.modalDelete = true;
                 this.DeleteText = res.data.content.message;
               } else {
                 this.showComfirmDelete = false;
                 this.modalDelete = true;
                 this.DeleteText = res.data.content.message;
               }
            }
          })
        }
        if (this.currentTxt == 'deleteOneVistor') {
          const hasMaterial = this.currentVisitor.hasMaterial;
          const visitorId = this.currentVisitor.visitorId;
          // console.log(visitorId);
          if (hasMaterial) {
            removeMaterial(visitorId).then((res) => {
              if (checkNested(res, 'data', 'content', 'model')) {
                this.isLoading = false;
                if (res.data.content.status === 1) {
                  this.showComfirmDelete = false;
                  this.modalDelete = true;
                  this.DeleteText = res.data.content.message;
                } else {
                  this.showComfirmDelete = false;
                  this.modalDelete = true;
                  this.DeleteText = res.data.content.message;
                }
              } else {
                this.showComfirmDelete = false;
                this.modalDelete = true;
                this.DeleteText = res.data.message;
              }
              this.deleteCheck = true;
            });
          } else {
            removeVisitor(visitorId).then((res) => {
              if (checkNested(res, 'data', 'content', 'model')) {
                this.isLoading = false;
                if (res.data.content.status === 1) {
                  this.showComfirmDelete = false;
                  this.modalDelete = true;
                  this.DeleteText = res.data.content.message;
                  this.closeMessage = false;
                  this.deleteCheck = true;
                } else {
                  this.showComfirmDelete = false;
                  this.modalDelete = true;
                  this.DeleteText = res.data.content.message;
                  this.deleteCheck = false;
                  this.closeMessage = true   
                }
              } else {
                this.showComfirmDelete = false;
                this.modalDelete = true;
                this.DeleteText = res.data.message;
                this.deleteCheck = true;
              }
            });
          }
        }
      },
      closest() {
        this.$emit('closeModal',false);
      },
      comfirmBtn() {
        if (this.deleteCheck || this.remindTip) {
          window.location.reload();
        }
      },
      redirectToLogin() {
        this.$emit('closeModal',false);
      },
      loadDialogData(Obj) {
        // console.log(Obj);
        if (Obj.currentTxt == 'remindApproval') {
          this.remindTip = true;
          this.comfirmDeleteTxt = false;
        } else if (Obj.currentTxt == 'deleteInvitationId' || Obj.currentTxt == 'deleteCheckGoods' || Obj.currentTxt == 'deleteOneVistor' || Obj.currentTxt == 'deleteSecurityCheckGoods') {
          this.comfirmDeleteTxt = true;
          this.remindTip = false;
          this.currentTxt = Obj.currentTxt;
          this.currentVisitor = Obj;
        } else if (Obj.currentTxt == 'forwaringModal') {
          this.showComfirmDelete = false;
          this.modalDelete = true;
          this.DeleteText = Obj.message;
          if (Obj.status == 1) {
            window.scrollTo(0, 0);
            this.closeMessage = false;
            this.deleteCheck = true;
          } else {
            window.scrollTo(0, 0);
            this.deleteCheck = false;
            this.closeMessage = true;
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .commit-modal {
    height: 100vh;
    background: rgba(0,0,0,.4);
    z-index: 1332;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    position: fixed;
    .confirm-wrapper {
      background: #fcfcfc;
      width: 300px;
      border-radius: 12px;
      font-size: 17px;
      text-align: center;
      .confirm-header {
        padding: 34.5px 0 20px;
        border-bottom: 1px solid #f0f1f2;
      }
      .confirm-btn {
        height: 40px;
        line-height: 40px;
        color: #e42029;
        div {
          cursor: pointer;
        }
        & > div:first-child {
          border-right: 1px solid #f0f1f2;
          font-size: 17px;
          color: #4a4a4a;
        }
      }
    }
    &.tip {
      .tip-inner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 270px;
        border-radius: 12px;
        background-color: #fcfcfc;
        text-align: center;
        .tip-text {
          padding: 20px 8px 15px;
          font-size: 17px;
          color: #4a4a4a;
        }
        .comfirmBtn {
          cursor: pointer;
         padding: 12px;
         font-size: 17px;
         color: #e42029;
        }
      }
      .icon-close {
        position: absolute;
        top: 10px;
        right: 5%;
        z-index: 10;
        font-size: 22px;
      }
    }
  }
</style>